import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { IdpCarrierManagementClient } from 'api-clients/rating-api-client';
import { OrgService } from 'src/shared/org/org.service';
import { UserService } from 'src/shared/user.service';

@Injectable()
export class ManageMyAgenciesAuthGuard {
  readonly #userService = inject(UserService);
  readonly #router = inject(Router);
  readonly #idpCarrierManagementClient = inject(IdpCarrierManagementClient);
  readonly #orgService = inject(OrgService);

  async canActivate(): Promise<true | UrlTree> {
    try {
      const isMgaAdmin = this.#userService.user.permissions.rating.mgaAdmin ?? false;

      const carriers = await this.#idpCarrierManagementClient.getIdpCarriersForOrganization();
      const hasCarriers = Array.isArray(carriers) && carriers.length > 0;

      const orgTree = await this.#orgService.getOrganizationAndBranchesTreeView();
      const hasSubAgencies = orgTree?.children?.length > 0;

      if (isMgaAdmin && hasCarriers && hasSubAgencies) {
        return true;
      }
      return this.#router.createUrlTree(['errors', '403']);
    } catch {
      return this.#router.createUrlTree(['errors', '500']);
    }
  }
}
